/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Failed_Create_ZipInputs */



/**
* | output |
* | --- |
* | "Failed to create zip file" |
*
* @param {Spaces_Toast_Failed_Create_ZipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_failed_create_zip = /** @type {((inputs?: Spaces_Toast_Failed_Create_ZipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Failed_Create_ZipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen der ZIP-Datei fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Failed to create zip file")
});